import styled from "styled-components";

export const ErrorMessage = styled.p`
  color: #f44336;
  font-size: 0.75rem;
`;
